import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#5C728A",
      d: "M22.54 6.42a2.76 2.76 0 0 0-1.945-1.957C18.88 4 12 4 12 4s-6.88 0-8.595.463A2.76 2.76 0 0 0 1.46 6.42C1 8.147 1 11.75 1 11.75s0 3.603.46 5.33a2.72 2.72 0 0 0 1.945 1.926c1.715.463 8.595.463 8.595.463s6.88 0 8.595-.463a2.72 2.72 0 0 0 1.945-1.926c.46-1.727.46-5.33.46-5.33s0-3.603-.46-5.33M9.75 15.021V8.48l5.75 3.271z"
    }, null, -1)
  ]))]))
}
export default { render: render }